import type { PublicProduct } from '../graphql/public'
import { PROMO_LABEL, promoOf } from '../lib/catalog'
import { SparkleIcon, StarIcon } from './icons'

// The kiosk's promo pill: white/95, plum text, bold — Popular / New / Chef's special.
export function PromoChip({ product, size = 20 }: { product: PublicProduct; size?: number }) {
  const promo = promoOf(product)
  if (!promo) return null
  return (
    <span
      className="inline-flex items-center space-x-[6px] px-[14px] py-[4px] rounded-full bg-white/95 text-brand-plum font-secondary font-bold shadow-[0_2px_6px_rgba(39,32,27,0.12)]"
      style={{ fontSize: size, lineHeight: 1.2 }}
    >
      {promo === 'NEW' ? <SparkleIcon size={size} /> : <StarIcon size={size} />}
      <span>{PROMO_LABEL[promo]}</span>
    </span>
  )
}
